import React from 'react';
import { Card } from '@material-ui/core';
import { toTitleCase } from '../../../helpers/helper';
import { getApplianceName } from '../../../helpers/itemizationDataHelper';

export default function RecoItem(props){
        let app = getApplianceName(props.details.appId, props.applianceList);
        return(
            <Card className="reco-item">
                <div className="product-info-wrapper">
                    <div className="image-container">
                        <img src={props.details.image} alt={props.details.recoTitle}/>
                    </div>
                    <div className="text-content">
                        <div className="text-wrapper">
                            <div className="title">
                                {props.details.title}
                            </div>
                            <div className="description">
                                {props.details.description}
                            </div>
                        </div>
                        {
                            props.productEducationEnabled && 
                            <button onClick={()=>props.handleCTAClick(props.details.recoId, props.details.link)} className="cta">{props.details.ctaText}</button>
                        }                        
                    </div>
                </div>
                {
                            props.productEducationEnabled && 
                            <div className="cta-mobile">
                                <button className="cta" onClick={()=>props.handleCTAClick(props.details.recoId, props.details.link)}>
                                    {props.translations["MARKETPLACE.EDUCATION_CTA_TEXT"]}
                                </button>
                            </div>
                        } 
                {
                    props.selfInstallEnabled && 
                    <div className="self-install">
                        {props.translations["DASHBOARD.MARKETPLACE.SELF_INSTALL"]}: <span className={"installable " + (props.details.selfInstall ? "yes" : "no")}>{props.details.selfInstall ? props.translations["DASHBOARD.COMMON.YES"]: props.translations["DASHBOARD.COMMON.NO"]}</span>                    
                    </div>
                }
                <div className="cta-wrapper">
                    {
                        props.marketplaceCTAEnabled && props.details.purchaseLinks.length > 0 &&
                        <div className="product-cta">
                            <p className="cta-description">{props.translations["DASHBOARD.MARKETPLACE.EXPLORE_APP"].replace("${app}", app)}</p>
                            <div className="purchase-btn-wrapper">
                                {props.details.purchaseLinks.map((item, index)=>(
                                    <div key={index} className="purchase-btn" onClick={()=>props.openPurchaseLink(item.link)}>
                                        {item.logo ? <img src={item.logo} alt={item.name}/> : <div className="link-name">{toTitleCase(item.name)}</div>}
                                    </div>
                                ))}
                            </div>                        
                        </div>
                    }
                    {
                        props.marketplaceCTAEnabled && props.details.contractorLinks && props.details.contractorLinks.link &&
                        <div className="product-cta">
                            <p className="cta-description">{props.translations["DASHBOARD.MARKETPLACE.HIRE_A_PROFESSIONAL"]}</p>
                            <div className="hire-professional-btn" onClick={()=>props.openPurchaseLink(props.details.contractorLinks.link)}>
                                {props.details.contractorLinks.name}
                            </div>
                        </div>
                    }
                </div>
                
                {
                    props.marketPlaceInsightEnabled && props.details.insight && props.details.insight.insightText && 
                    <div className="reco-insight-container">
                        <img src={props.insightBulbImage} alt=""/>
                        <div className="insight">
                            {props.details.insight.insightText}
                        </div>
                    </div>
                }
            </Card>
        )
    
}